import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectAuthStateState } from '../redux/auth-state.selectors';
import { map, tap } from 'rxjs/operators';
import { JWTService } from '../jwt-parser-service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store,
    private jwtService: JWTService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.jwtService.isLoggedIn();
    return this.store.pipe(
      select(selectAuthStateState),
      map(({ loggedIn }) => loggedIn),
      tap((loggedIn) => {
        console.log(route);
        if (!loggedIn) {
          this.router.navigate(['/login'], {
            queryParams: { from: state.url },
          });
        }
      })
    );
  }
}
